import { Component, ContentChild, EventEmitter, HostBinding, Input, Output, TemplateRef } from "@angular/core";

@Component({
	selector: "ic-item-form-group",
	templateUrl: "./item-form-group.component.html",
	styleUrls: ["./item-form-group.component.scss"],
	standalone: false,
})
export class ItemFormGroupComponent {
	formVisible = false;

	/** The selected items. */
	@Input() items: any[] = [];
	@Input()
	set showForm(value: { open: boolean }) {
		this.formVisible = value.open;
	}
	@Input() disabled = false;
	@HostBinding("class.error") @Input() error = false;

	@Output() openEvent = new EventEmitter<void>();
	@Output() closeEvent = new EventEmitter<void>();

	// Optional template to style the items in the list.
	@ContentChild("itemTmpl", { static: false }) itemTemplate: TemplateRef<any>;

	toggleForm() {
		this.formVisible = !this.formVisible;
		if (this.formVisible) {
			this.openEvent.emit();
		} else {
			this.closeEvent.emit();
		}
	}
}
